import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PlaceholderWrapper from "../../../Common/PlaceholderWrapper";
import PopupWrapper from "../../../Common/PopupWrapper";
import GridViewInlineEdit2 from "@mnjsplatform/components/lib/common/GridView/GridViewInlineEdit2";
import {ITEquipmentControl} from "./ITEquipmentControl";
import ITEquipment from "./ITEquipment";

class RequestForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            stateRuleCode: null,
            showITForm: false
        };
    }
    componentDidMount() {
        this.initialize();
    }
    initialize = async () => {
        await this.props.dispatch(this.props.dataItem_List.execute());
    }
    sendRequest = async() => {
        await this.props.dispatch(this.props.dataItem_List.save());
        await this.props.dispatch(this.props.dataItem_Send.execute());
        this.props.onClose();
    }
    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <button type="button" className="btn btn-regular -goahead ml1ex" data-dismiss="modal"
                    onClick={this.sendRequest}>{i18next.t("Save_And_Send_To_Approve")}</button>
            <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                    onClick={this.props.onClose}>{i18next.t("Close")}</button>
        </div>);
    }

    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "StateRuleCodeIT" && cellParams.row[cellParams.fieldInfo.Name]) {
            const formParams = Object.assign({}, cellParams, {
                onClick: (event) => {
                    this.setState({showITForm: true, stateRuleCode: cellParams.row[cellParams.fieldInfo.Name]});
                }});
            return (<ITEquipmentControl {...formParams} />)
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }
    render() {
        if (!this.props.dataItem_List.isInitialized) {
            return null;
        }
        return (<PopupWrapper title={this.props.title} onClose={this.props.onClose} popupVisible={true} renderButtons={this.renderButtons}>
            <div className="inwhite card">
                <GridViewInlineEdit2  dataItem={this.props.dataItem_List} readOnly={false} allowAdd={false}
                                      renderCellEx={this.renderCellEx}
                                      customFieldExMap={{ITEquipmentControl: (props) => <ITEquipmentControl onClick={() => {
                                              this.setState({showITForm: true, stateRuleCode: props.value});
                                          }} {...props}/>}}
                          pageSize={10} allowPagination={true} activePageSize={5} rowCursor="pointer"
                />
            </div>
            {this.state.showITForm && <ITEquipment stateRuleCode={this.state.stateRuleCode} readOnly={false}
                                                   onClose={() => {
                                                       this.setState({showITForm: false})
                                                   }}/>}
        </PopupWrapper>);
    }
}

RequestForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_List: PropTypes.object,
    onClose: PropTypes.func,
    stateRuleCode: PropTypes.string,
    title: PropTypes.string,
    dataItem_Send: PropTypes.object
}
RequestForm.defaultProps = {};
function mapStateToProps(state, ownProps) {
    return {
        dataItem_List: state.subRemoteWorkState.RemoteWorkHardwareSet_ListSRForPO,
        dataItem_Send: state.subRemoteWorkState.RemoteWorkClaim_SendToEDO
    }
}
export default connect(mapStateToProps)(RequestForm)